import { z } from 'zod';
import { UUIDSchema } from './common';
import { BaseUserSchema } from './user';
const InstructionCreatedBySchema = BaseUserSchema.pick({
    id: true,
    email: true,
    phone_number: true,
    first_name: true,
    last_name: true,
    job_title: true,
}).extend({ team: z.string().optional() });
const AppraiserInstructionShape = {
    uuid: UUIDSchema,
    title: z.string(),
    description: z.string(),
    created_by: InstructionCreatedBySchema,
    organization_uuid: UUIDSchema,
    customer_uuid: UUIDSchema.optional(),
    updated_on: z.string(),
    created_on: z.string(),
};
export const AppraiserInstructionSchema = z.object(AppraiserInstructionShape);
export const NewAppraiserInstructionSchema = AppraiserInstructionSchema.pick({ title: true, description: true, customer_uuid: true });
const AppraiserInstructionListShape = {
    instructions: AppraiserInstructionSchema.array(),
};
export const AppraiserInstructionListSchema = z.object(AppraiserInstructionListShape);
